export default __webpack_public_path__ + "static/assets/d9c4cd381469eefd6cbe5e0c96b79b37.svg";